import React, { useState, useEffect } from 'react';
import Editor from '@monaco-editor/react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp, faEraser } from '@fortawesome/free-solid-svg-icons';

const CsvPreview = (props) => {
  const { editorTheme } = props
  const [originalInput, setOriginalinput] = useState('');
  const [csvData, setCsvData] = useState([]);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const content = e.target.result;
      console.log(content);
      setOriginalinput(content);
    };
    reader.readAsText(file);
  };

  useEffect(() => {
    if (originalInput === '') {
      return setCsvData([]);
    }
    const rows = originalInput.split('\n');
    const data = rows
      .filter(row => row.trim() !== '')  // Remove blank rows
      .map(row => row.split(/[;,]/));
        setCsvData(data);
  }, [originalInput]);

  return (
    <div className="grid grid-cols-1 my-4 xl:grid-cols-2 xl:gap-4">
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-blue-600 p-2'>CSV Input</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <Editor 
              height="25vh"
              value={originalInput}
              onChange={(value, event) => setOriginalinput(value)}
              language="csv"
              defaultValue={originalInput}
              theme={editorTheme}
              className="block p-2.5 w-full text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            />
          </div>
          <div className="px-4 py-2 text-gray-400rounded dark:border-gray-600">
            <input
              type="file"
              accept='.csv'
              onChange={handleFileUpload}
              className='hidden'
              name='file1'
            />
            <button
              type="button"
              onClick={() => document.querySelector('input[name="file1"]').click()}
              className="text-white bg-blue-500 hover:bg-blue-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faCloudArrowUp}/>
              &nbsp; Browse your CSV file
            </button>
            &nbsp;&nbsp;
            <button
              onClick={() => setOriginalinput('')}
              type="button"
              className="text-white bg-gray-400 hover:bg-gray-700 focus:ring-4 focus:outline-none font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center me-2 mb-2"
            >
              <FontAwesomeIcon icon={faEraser}/>
              &nbsp; Reset
            </button>
          </div>
        </div>
      </div>
      <div className="col-span-2">
        <div className="p-4 mb-4 space-y-6 bg-white border border-gray-200 rounded-lg shadow-sm 2xl:col-span-2 dark:border-gray-700 sm:p-6 dark:bg-gray-800">
          <div className="px-4 py-2 text-gray-400 border border-gray-200 border-dashed rounded dark:border-gray-600">
            <h3 className='uppercase border-l-4 border-yellow-600 p-2'>CSV Preview</h3>
          </div>
          <div className="px-4 py-2 text-gray-400 rounded dark:border-gray-600">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  {csvData.length > 0 &&
                    csvData[0].map((header, index) => (
                      <th scope="col" className="px-6 py-3" key={index}>{header}</th>
                    ))}
                </tr>
              </thead>
              <tbody>
                {csvData.length > 1 &&
                  csvData.slice(1).map((row, rowIndex) => (
                    <tr key={rowIndex} className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className='px-6 py-4'>{cell}</td>
                      ))}
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CsvPreview;
